import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ImPropTypes from "react-immutable-proptypes";
import { fromJS } from "immutable";

const noop = () => {};

export default class ProfileSelector extends React.Component {
  static propTypes = {
    ariaControls: PropTypes.string,
    profile: PropTypes.oneOfType([
      ImPropTypes.list,
      ImPropTypes.set,
      ImPropTypes.seq,
    ]),
    controlId: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
  };

  static defaultProps = {
    onChange: noop,
    value: null,
    profile: fromJS([]),
  };

  componentDidMount() {
    // Needed to populate the form, initially
    if (this.props.profile) {
      this.props.onChange(this.props.profile.first());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.profile || !nextProps.profile.size) {
      return;
    }

    if (!nextProps.profile.includes(nextProps.value)) {
      nextProps.onChange(nextProps.profile.first());
    }
  }

  onChangeWrapper = (e) => {
    this.props.onChange(e.target.value);
  };

  render() {
    let { ariaControls, ariaLabel, className, profile, controlId, value } =
      this.props;

    return (
      <div className={"content-type-wrapper " + (className || "")}>
        <select
          aria-controls={ariaControls}
          aria-label={ariaLabel}
          className="content-type"
          id={controlId}
          onChange={this.onChangeWrapper}
          value={value || ""}
        >
          {profile
            .map((val) => {
              return (
                <option key={val} value={val}>
                  {val}
                </option>
              );
            })
            .toArray()}
        </select>
      </div>
    );
  }
}
